import React, { createContext, useContext, useState, useEffect } from 'react';

interface AppointmentsContextType {
    appointments: any[];
    loading: boolean;
    getOverrunServices: () => any[];
    addAppointment: (appointment: any) => void;
    updateAppointment: (id: string, updates: any) => void;
    startService: (appointmentId: string) => void;
    endService: (appointmentId: string) => void;
}

const AppointmentsContext = createContext<AppointmentsContextType | undefined>(undefined);

export const AppointmentsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [appointments, setAppointments] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // This will be replaced with real data fetching
        setLoading(false);
    }, []);

    const getOverrunServices = () => {
        // Return services that are running over time
        return appointments.filter(apt => apt.isOverrun);
    };

    const addAppointment = (appointment: any) => {
        setAppointments(prev => [...prev, appointment]);
    };

    const updateAppointment = (id: string, updates: any) => {
        setAppointments(prev => prev.map(apt =>
            apt.id === id ? { ...apt, ...updates } : apt
        ));
    };

    const startService = (appointmentId: string) => {
        updateAppointment(appointmentId, {
            status: 'in-progress',
            startedAt: new Date()
        });
    };

    const endService = (appointmentId: string) => {
        updateAppointment(appointmentId, {
            status: 'completed',
            completedAt: new Date()
        });
    };

    return (
        <AppointmentsContext.Provider value={{
            appointments,
            loading,
            getOverrunServices,
            addAppointment,
            updateAppointment,
            startService,
            endService
        }}>
            {children}
        </AppointmentsContext.Provider>
    );
};

export const useAppointments = () => {
    const context = useContext(AppointmentsContext);
    if (!context) {
        throw new Error('useAppointments must be used within AppointmentsProvider');
    }
    return context;
};